import Slider from "react-slick";
import moment from "moment/moment";
import useTutorial from "../../../hooks/useTutorial";
import { BaSeIcon, BaSeHeading5 } from "@base/react";
import MenuDropdown from "../../../components/menu-dropdown";

const TutorialProjectedCashFlow = () => {
  const dataContent = {
    mesBase: "DD/MM/AAAA",
    saldoInicial: 0,
    saidas: [],
  };

  const SettingsSliderCashFlow = {
    dots: dataContent?.saidas.length >= 1,
    infinite: false,
    speed: 500,
    slidesToShow: dataContent?.saidas.length
      ? dataContent?.saidas.length >= 2
        ? 3
        : dataContent?.saidas.length
      : 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: false,
    fade: false,
    centerMode: false,
    adaptiveHeight: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20",
          variableWidth: false,
        },
      },
    ],
  };

  const extractSections = (data) => {
    const sections = [];

    for (const saida of data.saidas) {
      const { entries } = saida;

      for (const entry of entries) {
        const { uuid, title } = entry;
        if (!sections.some((section) => section.sectionId === uuid)) {
          sections.push({ title, sectionId: uuid });
        }
      }
    }

    return sections;
  };

  const PAGE_KEY = "fluxoCaixaProjetado";

  useTutorial({
    currentStep: "15",
    pageKey: "fluxoCaixaProjetado",
    previousKey: "resultadosEMetas",
    steps: [
      {
        element: ".cash-flow",
        popover: {
          title: "Fluxo de caixa projetado",
          description: `Planeje seu fluxo de caixa! Crie projeções financeiras para entender sua capacidade mensal de
          pagamento e garantir equilíbrio financeiro.`,
          side: "bottom",
          align: "center",
        },
      },
    ],
    onNextButtonClick: (driverObj) => {
      const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

      if (tutorials["garantias"]) {
        tutorials["garantias"].finalizado = false;
      }

      tutorials[PAGE_KEY] = { ...tutorials[PAGE_KEY], finalizado: true };
      localStorage.setItem("tutorials", JSON.stringify(tutorials));

      const botaoProx = document.querySelector("#botaoSeguirTutorial button");
      botaoProx.click();
      driverObj.drive(0);
    },
  });

  return (
    <div className="step cash-flow">
      <BaSeHeading5
        color="#005EB8"
        fontFamily="Alegreya Sans"
        isBold
        className="mt-0"
      >
        Mês atual:
      </BaSeHeading5>
      <div className="wrapper-flux title">
        <p className="date">{moment().format("MMMM [de] YYYY")}</p>
      </div>
      <Slider
        className={"SettingsSliderCashFlow empty"}
        {...SettingsSliderCashFlow}
      >
        <div className="wrapper-flux">
          <h3>Fluxo de caixa projetado</h3>
          <span className={"card-flux balance has-balance"}>
            <div className="header">
              Saldo inicial em caixa
              <BaSeIcon color="#005EB8" description="Menu" size={24} />
            </div>
            <div className="has-balance">
              <p>Período: Não informado</p>

              <p>Valor: Não informado</p>
            </div>
          </span>
          <span className="card-flux">Entradas</span>
          <div className="exits">
            <div className="card-flux">
              <div className="content">
                <div className="title">Saídas</div>
                <div className="title-values">
                  {dataContent?.saidas.length
                    ? extractSections(dataContent).map((item) => (
                        <div className="title-exits" key={item.sectionId}>
                          <p>{item.title || "Saída"}</p>
                          <MenuDropdown
                            data={[
                              {
                                name: "Editar",
                                icon: (
                                  <BaSeIcon
                                    color="#617385"
                                    description="Edit"
                                    name="design/pencil-line"
                                    size={24}
                                  />
                                ),
                              },
                              {
                                name: "Excluir",
                                icon: (
                                  <BaSeIcon
                                    color="#617385"
                                    description="Trash"
                                    name="trash-alt"
                                    size={24}
                                  />
                                ),
                              },
                            ]}
                            // isOpen={menuOptions === item.sectionId}
                          />
                        </div>
                      ))
                    : ""}
                </div>
              </div>
            </div>
          </div>
          <span className="card-flux capacity card-flux-gray active">
            Capacidade mensal de pagamento
          </span>
        </div>
      </Slider>
    </div>
  );
};

export default TutorialProjectedCashFlow;
